import React, { Component } from "react";
class LabelDialog extends React.Component
{
    
    constructor(props)
    {
        super(props);

    }



    render()
    {
        return (<>
                <div className = "dialog-Label-Title" style={{width: this.props.width}}>
                    {this.props.title}
                </div>
                
            </>);
    }

}

export default LabelDialog;